import AppState from "../../util/AppState";
import { useTranslation } from "react-i18next";
import React from "react";
import languageIcon from "../../resources/language-icon.svg";

function Footer(props) {
  const { t } = useTranslation("translation");
  if (
    props.state === AppState.ATTRACT_SCREEN ||
    props.state === AppState.MESSAGE_SCREEN ||
    props.state === AppState.LOADING_SCREEN ||
    props.state === AppState.STAGING_SCREEN
  ) {
    return (
      <div className="footer">
        <div
          id="languageLabel"
          className="languageButton"
          onClick={props.transitionToSelectLanguageScreen}
          style={{ order: t("position.languageButtonOrder") }}
        >
          <div className="languageIcon">
            <img id="languageIcon" src={languageIcon} alt="languageIcon" />
          </div>
          <p>{t("Language")}</p>
        </div>
      </div>
    );
  } else if (props.state === AppState.ENTER_LOYALTY_CARD_SCREEN) {
    return (
      <div className="footer">
        <div
          className="languageButton"
          id="languageLabel"
          onClick={props.transitionToSelectLanguageScreen}
          style={{ order: t("position.languageButtonOrder") }}
        >
          <div className="languageIcon">
            <img id="languageIcon" src={languageIcon} alt="languageIcon" />
          </div>
          <p>{t("Language")}</p>
        </div>
        <div
          className="rightFooterButton"
          onClick={props.transitionToPreviousScreen}
          id="enterLoyaltyScreenBackLabel"
        >
          <p className="footerButtonText">{t("Back")}</p>
        </div>
      </div>
    );
  } else if (props.state === AppState.SELECT_LANGUAGE_SCREEN) {
    return (
      <div className="footer">
        <div
          className="languageButton"
          id="languageLabel"
          onClick={props.transitionToSelectLanguageScreen}
          style={{ order: t("position.languageButtonOrder") }}
        >
          <div className="languageIcon">
            <img id="languageIcon" src={languageIcon} alt="languageIcon" />
          </div>
          <p>{t("Language")}</p>
        </div>
        <div
          className="rightFooterButton"
          onClick={props.transitionToPreviousScreen}
          id="selectLanguageScreenCancelLabel"
        >
          <p className="footerButtonText">{t("Cancel")}</p>
        </div>
      </div>
    );
  } else if (props.state === AppState.SELECT_SITE_AND_WALL_ID_SCREEN) {
    return (
      <div className="footer">
        <div
          className="languageButton"
          id="languageLabel"
          onClick={props.transitionToSelectLanguageScreen}
          style={{ order: t("position.languageButtonOrder") }}
        >
          <div className="languageIcon">
            <img id="languageIcon" src={languageIcon} alt="languageIcon" />
          </div>
          <p>{t("Language")}</p>
        </div>
        <div
          className="scanQRCodeAgainButton"
          onClick={() => {
            localStorage.removeItem("StyleSheetURL");
            localStorage.removeItem("SupportedLocales");
            localStorage.removeItem("SharedKey");
            localStorage.removeItem("SecretKey");
            localStorage.removeItem("orgID");
            props.transitionToStagingScreen();
          }}
          id="scanQRCodeAgainLabel"
        >
          <p>{t("Start over")}</p>
        </div>
        <div
          className="selectIDcontinueButton"
          onClick={props.transitionToLoadingScreen}
          id="selectIDcontinueLabel"
          style={
            props.selectIdScreenContinueBtn
              ? { background: "#2E7DF7", color: "#FFFFFF" }
              : {}
          }
        >
          <p
            className="footerButtonText"
            style={props.selectIdScreenContinueBtn ? { color: "#FFFFFF" } : {}}
          >
            {t("Continue")}
          </p>
        </div>
      </div>
    );
  } else if (props.state === AppState.ADMIN_SCREEN) {
    return (
      <div className="footer">
        <div
          className="leftFooterButton"
          onClick={props.transitionToAttractScreen}
          id="adminGoBackButtonLabel"
        >
          <p className="footerButtonText">{t("Back")}</p>
        </div>
      </div>
    );
  } else if (props.state === AppState.SCANNER_DETAILS_SCREEN) {
    return (
      <div className="footer">
        <div
          className="leftFooterButton"
          onClick={props.transitionToAdminScreen}
          id="scannerDetailsGoBackButtonLabel"
        >
          <p className="footerButtonText">{t("Back")}</p>
        </div>
      </div>
    );
  } else {
    return (
      <div className="footer">
        <div className="placeholder"></div>
      </div>
    );
  }
}

export default Footer;
